/**
 * Estimate
 * 
 * @Author: Focci
 * @Date: 2023-08-18 10:01:40
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-18 10:01:40
 */

'use client'

import PropTypes from 'prop-types'
import Tab from '@comp/Tab'
import useLazyComponent from '@hook/useLazyComponent'
import clsx from 'clsx'
import { useMemo, useState } from 'react'
import { useTranslations } from 'next-intl'
import { isAU } from '@lib/utils'
import { Waypoint } from 'react-waypoint'
import PropertyItemScoff from '../PropertyItemScoff'

function getTabOptions(house, th) {
  const options = []
  options.push({ label: th('hgEstimate'), value: 'estimate' })

  if(house?.propertyId && !isAU && house.hide_avm_trending) {
    options.push({ label: th('trendsPastFineYears'), value: 'trends' })
  }

  return options
}

function EstimateTitle({ options, ...props }) {
  const th = useTranslations('house')

  return isAU 
    ? th('hgEstimate') 
    : (
      <Tab
        className="pb-2"
        activeClassName="text-primary border-b border-b-2 border-primary"
        unActiveClassName="text-base text-meta"
        activeSign={<span />}
        options={options} 
        {...props}
      />
    )
}

export default function Estimate({
  house = {},
}) {
  const th = useTranslations('house')
  const options = useMemo(() => getTabOptions(house, th), [house, th])
  const [tab, setTab] = useState(options[0]?.value)

  const { Wedget: EstimateBody, getWedget, ready } = useLazyComponent()
  
  return (
    <PropertyItemScoff
      id="module-estimate"
      moduleName={th('hgEstimate')}
      title={
        <EstimateTitle
          options={options} 
          value={tab}
          onChange={({ value }) => setTab(value)} 
        />
      }
    >
      <Waypoint onEnter={() => getWedget(() => import('./EstimateBody'))}>
        <div className={clsx(['min-h-[12rem]', !ready && 'bg-cf0'])}>
          <EstimateBody
            house={house}
            tabName={tab}
          />
        </div>
      </Waypoint>
    </PropertyItemScoff>
  )
}

Estimate.propTypes = {
  house: PropTypes.object,
}
